import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import React from "react";
import { useGetEmployeeHistoryQuery } from "entitites/employees/api/employeesApi";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import dayjs from "dayjs";

const translationObject: { [key: string]: string } = {
  fio: "ФИО",
  email: "Электронная почта",
  personalEmail: "Личная почта",
  phone: "Телефон",
  personalPhone: "Личный телефон",
  telegram: "Телеграм",
  city: "Город",
  dob: "Дата рождения",
  address: "Адрес",
  company: "Компания",
  direction: "Направление",
  department: "Отдел",
  adviser: "Тимлидер",
  schedule: "График",
  workTime: "Рабочее время",
  positionName: "Название должности",
  statusName: "Статус",
  appl: "№ Задачи S4S",
  status: "Статус S4S",
};

export const HistoryView = () => {
  const location = useLocation();
  const {
    data: history,
    isLoading,
    isUninitialized,
    isError,
    error,
  } = useGetEmployeeHistoryQuery(location.pathname.split("/")[2]);

  if (isLoading || isUninitialized) {
    return (
      <Box mt={3} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }
  if (isError) {
    return (
      <Box mt={3} display="flex" justifyContent="center">
        {JSON.stringify(error)}
      </Box>
    );
  }

  function flattenObject(obj: { [key: string]: any }) {
    let result: { [key: string]: any } = {};
    for (let key in obj) {
      if (key === "eduInfo") {
        continue;
      }
      if (Array.isArray(obj[key])) {
        obj[key].map(
          (item: { label: string; value: string }, index: number) =>
            (result[`${index + 1}. ${item.label}`] = item.value)
        );
        continue;
      }
      if (typeof obj[key] === "object" && obj[key] !== null) {
        let flatObject = flattenObject(obj[key]);
        for (let flatKey in flatObject) {
          result[flatKey] = flatObject[flatKey];
        }
      } else {
        result[key] = obj[key];
      }
    }
    return result;
  }

  return (
    <Box>
      <Typography textTransform="uppercase" fontWeight={600} my={2.5} mb={5}>
        История изменений
      </Typography>
      {history.map((item) =>
        Object.values(flattenObject(item.nextObj)).length ||
        Object.values(flattenObject(item.prevObj)).length ? (
          <Accordion
            key={item.date + item.initiator}
            sx={{ bgcolor: "background.default" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Box display="flex" gap={2}>
                <Typography width={150} fontWeight={600} fontSize={14}>
                  {item.initiator}
                </Typography>
                <Typography
                  width={115}
                  fontWeight={500}
                  fontSize={14}
                  color="#595959"
                >
                  изменений:{" "}
                  {Object.values(flattenObject(item.nextObj)).length ||
                    Object.values(flattenObject(item.prevObj)).length}{" "}
                </Typography>
                <Typography
                  width={150}
                  fontWeight={500}
                  fontSize={14}
                  color="#595959"
                >
                  {dayjs(item.date).format("DD.MM.YYYY в HH:mm")}
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box width={230} display="flex" flexDirection="column">
                  {Object.entries(flattenObject(item.prevObj))
                    .sort()
                    .map((item: string[]) => (
                      <Typography
                        key={item[0]}
                        fontWeight={500}
                        width={230}
                        fontSize={14}
                      >
                        <Typography
                          color="#CFA100"
                          fontSize={14}
                          component="span"
                        >
                          {translationObject[item[0]]
                            ? translationObject[item[0]]
                            : item[0]}
                          :{" "}
                        </Typography>
                        {item[1]}
                      </Typography>
                    ))}
                </Box>
                <ArrowRightAltIcon htmlColor="#787977" />
                <Box width={230} display="flex" flexDirection="column">
                  {Object.entries(flattenObject(item.nextObj))
                    .sort()
                    .map((item) => (
                      <Typography
                        key={item[0]}
                        fontWeight={500}
                        width={230}
                        fontSize={14}
                      >
                        <Typography
                          color="#CFA100"
                          fontSize={14}
                          component="span"
                          maxWidth={130}
                          overflow="hidden"
                        >
                          {translationObject[item[0]]
                            ? translationObject[item[0]]
                            : item[0]}
                          :{" "}
                        </Typography>
                        {item[1]}
                      </Typography>
                    ))}
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        ) : (
          <React.Fragment key={item.date + item.initiator}></React.Fragment>
        )
      )}
    </Box>
  );
};
